export default "__VITE_ASSET__Cfqh0B01__"